import { Form, Input, InputNumber } from "antd";
import React from "react";

const AllowedMaximumReportUploads: React.FC = () => {
  return (
    <Form.Item
      name="maximumReportUploads"
      label="Allowed Maximum Report Uploads"
      rules={[
        {
          required: true,
          message: "Allowed Maximum Report Uploads is required",
        },
      ]}
    >
      <InputNumber style={{ width: "100%" }} />
    </Form.Item>
  );
};

export default AllowedMaximumReportUploads;
